(function (angular, app) {
   "use strict";

   angular.module(app.modules.group.name)
      .controller(app.modules.group.routes.lookup.controller, GroupLookupController);
      
   GroupLookupController.$inject = ["$scope", "$q", "$window", "$timeout", "ngDialog"
      , app.modules.group.services.groups
      , app.modules.common.constants.appsettings
      , app.modules.common.constants.appmessaging
      , app.modules.common.services.functions
      , app.modules.common.services.storage
      , app.modules.ui.services.alerts
   ];
   
   function GroupLookupController($scope, $q, $window, $timeout, ngDialog
      , ggGroupSvc
      , ggSettings
      , ggMessaging
      , ggFunctions
      , ggStorage
      , ggAlertSvc
   ){
      
      // Scopes
      $scope.PopupAlert = new ggAlertSvc.popup;
      $scope.Group = null;

      // Assign this to object so it can be updated from watcher
      var ctrl = this;
      
      ctrl.isLoaded = true;
      
      $scope.View = {
         tabs : {
            current : 2
            , types: {
               search: 1
               , follower: 2
               , creator : 3
            }
            , select: function (tab) {
               if (!tab) {
                  tab = $scope.View.tabs.current;
               }


               $scope.View.tabs.current = tab; // Set Current
               app.Member.Session.bookmark.groups.tab = tab; // Remember selected tab
               $scope.f.scrollLimit.reset(); // Reset Scroll limit

               if ($scope.View.tabs.current == $scope.View.tabs.types.follower) {
                  $scope.Content.byFollower.fetch();
               }
               if ($scope.View.tabs.current == $scope.View.tabs.types.creator) {
                  $scope.Content.byCreator.fetch();
               }
            }
            , isActive: function (tab) {
               return tab == $scope.View.tabs.current;
            }
         }
      }

      $scope.Content = {
      
         init: function () {

            var tab1 = app.Member.Session.bookmark.groups.tab;
            $scope.View.tabs.select(tab1);

            if (tab1 == $scope.View.tabs.types.search) {
               $scope.Content.bySearch.results = app.Member.Session.bookmark.groups.results;
               $scope.Content.bySearch.isSearch = true;
            }

            ggFunctions.scrollToTop(0);
         }
         , bySearch: {
            isDirty: false
            , isSearch: false
            , countrylist: {
               data: [] //app.data.Countries
            }
            , regionlist: {
               data: [] //app.data.Regions
            }
            , form: {
                name: ""
                , isPrivate : false
            }
            , reset: function () {
               $scope.Content.bySearch.isSearch = false;
               $scope.Content.bySearch.results = [];
               app.Member.Session.bookmark.groups.results = [];
            }
            , search: function (isValid) {
               $scope.Content.bySearch.results = [];
               $scope.Content.bySearch.isDirty = true;
               if (isValid) {
                  $scope.Content.bySearch.fetch();
               } else {
                  // nothing to do as angular handles error
               }
            }
            , results: []
            , fetch: function (isValid) {
               if (isValid) {
                  ggGroupSvc.search.fetchGroupSearch($scope.Content.bySearch.form).then(function (data) {
                     if (data && data.status == "200") {
                        $scope.Content.bySearch.results = data.data.value;
                        app.Member.Session.bookmark.groups.results = data.data.value;
                     }
                  }).finally(function () {
                     $scope.Content.bySearch.isSearch = true;
                     ggFunctions.toggleProcessing(false);
                  });
               }
            }
         }
         , byFollower: {
            results : []
            , isSearch : false
            , fetch  : function(isRefresh){

               var processData = function (results) {
                  if (results.length > 0) {
                     // Sort on date
                     results.sort(function (a, b) {
                        var d1 = a.group.name;
                        var d2 = b.group.name;
                        var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                        return v;
                     });
                  }

                  $scope.Content.byFollower.results = results
                  $scope.Content.byFollower.isSearch = true;
                  //return $q.when();
               }

               return app.Member.Network.Data.Groups.fetch(true).then(function (data) {
                  return processData(data);
               }).finally(function () {
                  ggFunctions.toggleProcessing(false);
               });

            }
         }
         , byCreator: {
            results: []
            , isSearch : false
            , fetch: function (isRefresh) {
               var processData = function (results) {
                  if (results.length > 0) {
                     // Sort on date
                     results.sort(function (a, b) {
                        var d1 = a.group.name;
                        var d2 = b.group.name;
                        var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                        return v;
                     });
                  }

                  $scope.Content.byCreator.results = results
                  $scope.Content.byCreator.isSearch = true;
                  //return $q.when();
               }

                  return app.Member.Network.Data.Groups.allmygroups.fetch(true).then(function (data) {
                     return processData(data);
                  }).finally(function () {
                     ggFunctions.toggleProcessing(false);
                  });

            }
         }

         , selectGroup: function (groupId) {
            ggFunctions.goToPage(app.modules.group.routes.detail.path + "?groupId=" + groupId);
         }
         , refresh: function () {
            if ($scope.View.tabs.current == $scope.View.tabs.types.follower) {
               $scope.Content.byFollower.fetch(true);
            }
            if ($scope.View.tabs.current == $scope.View.tabs.types.creator) {
               $scope.Content.byCreator.fetch(true);
            }
         }
      }

      // limiting scroll height
      angular.element($window).bind("scroll", function () {
         var windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
         var body = document.body, html = document.documentElement;
         var docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
         var windowBottom = windowHeight + window.pageYOffset;
         if (windowBottom >= docHeight && !$scope.f.scrollLimit.isScrolling) {
            $scope.f.scrollLimit.scroll();
         }
      });

      $scope.f = {
         scrollLimit: {
            isScrolling : false
            , current: ggSettings.defaultScrollLimit
            , reset : function(){
               $scope.f.scrollLimit.current = ggSettings.defaultScrollLimit;
            }
            , scroll: function () {

               $scope.f.scrollLimit.isScrolling = true;
               $scope.$apply();
               $timeout(function () {
                  $scope.f.scrollLimit.current = $scope.f.scrollLimit.current + ggSettings.defaultScrollLimit;
                  $scope.f.scrollLimit.isScrolling = false;
                  $scope.$apply();
               }, 200);
            }
         }
         , isFollowing: function (groupId) {
            return app.Member.Network.Data.Groups.isFollowing(groupId);
         }
         , newGroup : function () {
            ggFunctions.goToPage(app.modules.group.routes.setup.path);
         }
         , getThemeName : function (themeId) {
            themeId = themeId ? themeId : 1;
            return ggFunctions.fetchThemeById(themeId).className;
         }
         , formatDateString: function (d) {
            return ggFunctions.formatDateString(d, "m/d/yyyy",null)
         }
      }

      $scope.Content.init();
   }
}(angular, app));

